import { Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Bar,
  BarChart,
  Brush,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import { IconTransactions, Modal } from '../../../../../component';
import { List } from '../../../../../component/list/list';
import { colors } from '../../../../../shared/constants';
import { modalOpen } from '../../../redux/dashboardActions';

const BuildingDetailsModalTransactions: React.FC = () => {
  const dispatch = useDispatch();
  const { preference } = useSelector((state: any) => state.layoutState);
  const nls = require(`../../nls/${preference.language.id}.json`);
  const { statusModal } = useSelector((state: any) => state.dashboardState);
  const { buildingData } = useSelector(
    (state: any) => state.realtyTransactionsState
  );

  const structureData = [
    'use_type',
    'realties_amount',
    'construction_year',
    'construction_pattern',
    'units_traded',
  ];

  let indexColorCharts1 = -1;
  let indexColorCharts2 = -1;

  let tableHeader = [
    {
      text: nls.area,
      column: 'area',
      className: 'text-center',
    },
    {
      text: nls.total_units,
      column: 'total_units',
      className: 'text-center',
    },
    {
      text: nls.total_transacted_units,
      column: 'total_transacted_units',
      className: 'text-center',
    },
  ];

  let tableInfo = buildingData.table?.map((e: any) => {
    let item = {};
    const area = Object.keys(e)[0];
    const val = e[area];

    const itensDate = Object.keys(e[area])
      .filter((tl: any) => {
        return !tl.includes('total');
      })
      .map((tl: any) => {
        const valth = tableHeader.filter(
          (th: any) => th.column === `percentual_transactioned--${tl}`
        );
        if (valth.length <= 0) {
          tableHeader = [
            ...tableHeader,
            {
              text: `${nls.transacted} ${tl}`,
              column: `percentual_transactioned--${tl}`,
              className: 'text-center',
            },
          ];
        }
        return {
          [`percentual_transactioned-${tl}`]: `${e[area][tl].transacted_units} (${e[area][tl].percentual_transactioned}%)`,
          [`percentual_transactioned_${tl}`]:
            e[area][tl].percentual_transactioned,
          [`transacted_units_${tl}`]: e[area][tl].transacted_units,
        };
      });
    item = {
      ...item,
      id: area,
      area: `${area} m²`,
      total_units: val?.total?.total_units,
      total_transacted_units: val?.total?.total_transacted_units,
    };

    itensDate.forEach((f) => {
      item = { ...item, ...f };
    });

    return item;
  });

  const chartList = buildingData?.chart?.map((e: any) => {
    let itens = {
      name: e.name,
    };
    tableInfo?.forEach((t: any) => {
      itens = {
        ...itens,
        [t.id]: t?.[`transacted_units_${e.name}`]
          ? Number(t?.total_units) - Number(t?.[`transacted_units_${e.name}`])
          : Number(t?.total_units),
        [`transacted${t.id}`]: t?.[`transacted_units_${e.name}`]
          ? t?.[`transacted_units_${e.name}`]
          : 0,
        [`percent${t.id}`]: `${
          t?.[`percentual_transactioned_${e.name}`]
            ? t?.[`percentual_transactioned_${e.name}`]
            : 0
        } %`,
      };
    });

    return itens;
  });

  const CustomLegend = ({ data, chart }: any) => {
    let colorIndex = -1;
    const listLegend = data.map((l: any, i: number) => {
      if (
        !l.includes('transact') &&
        !l.includes('percent') &&
        !l.includes('name')
      ) {
        colorIndex++;
        return (
          <div key={`legenda-${i}-${chart}`}>
            <svg
              className="recharts-surface"
              width="14"
              height="14"
              viewBox="0 0 32 32"
            >
              <path
                stroke="none"
                fill={colors[colorIndex]}
                d="M16 0c-8.837 0-16 7.163-16 16s7.163 16 16 16 16-7.163 16-16-7.163-16-16-16zM16 20c-2.209 0-4-1.791-4-4s1.791-4 4-4c2.209 0 4 1.791 4 4s-1.791 4-4 4z"
              ></path>
            </svg>
            <span
              className="recharts-legend-item-text"
              style={{ color: colors[colorIndex] }}
            >
              {' '}
              {l} m²
            </span>
          </div>
        );
      } else return null;
    });
    const totais = (
      <div>
        <svg
          className="recharts-surface"
          width="14"
          height="14"
          viewBox="0 0 32 32"
        >
          <path
            stroke="none"
            fill={'#a2a4a4'}
            d="M16 0c-8.837 0-16 7.163-16 16s7.163 16 16 16 16-7.163 16-16-7.163-16-16-16zM16 20c-2.209 0-4-1.791-4-4s1.791-4 4-4c2.209 0 4 1.791 4 4s-1.791 4-4 4z"
          ></path>
        </svg>
        <span
          className="recharts-legend-item-text"
          style={{ color: '#a2a4a4' }}
        >
          {' '}
          {nls.foundRecords}
        </span>
      </div>
    );
    return (
      <div className="box-legend-chart">
        {listLegend}
        {totais}
      </div>
    );
  };

  const CustomTooltip = ({ active, payload, label }: any) => {
    let colorIndex = -1;
    if (active && payload && payload.length) {
      const listToltip = payload.filter(
        (e: any) => !e.name.includes('transacted')
      );

      return (
        <div className="custom-tooltip">
          <label className="label">
            <strong>{`${label}`}</strong>
          </label>
          <div className="custom-tooltip-scrool">
            {listToltip?.map((e: any, i: number) => {
              colorIndex++;
              return (
                <div key={`custom-tooltip-${i}`}>
                  <p style={{ color: colors[colorIndex] }}>
                    <strong>{e.name} m²</strong>
                  </p>
                  <p>
                    {nls.dashTransacted}:{' '}
                    <strong style={{ color: colors[colorIndex] }}>
                      {' '}
                      {Number(e.payload[`transacted${e.name}`])}
                    </strong>
                  </p>
                  <p>
                    {nls.dashFoundRecords}:{' '}
                    <strong style={{ color: e.color }}>
                      {' '}
                      {Number(e.payload[e.name])}
                    </strong>
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      );
    }
    return null;
  };

  const CustomTooltipPercent = ({ active, payload, label }: any) => {
    if (active && payload && payload.length) {
      const listToltip = payload.filter(
        (e: any) => !e.name.includes('transacted')
      );
      return (
        <div className="custom-tooltip">
          <label className="label">
            <strong>{`${label}`}</strong>
          </label>
          <div className="custom-tooltip-scrool">
            {listToltip?.map((e: any, i: number) => {
              return (
                <div key={`custom-tooltip-${i}`}>
                  <p style={{ color: colors[i] }}>
                    <strong>{e.name} m²</strong>
                  </p>
                  <p>
                    {nls.percentileTransacted}:{' '}
                    <strong style={{ color: colors[i] }}>
                      {' '}
                      {e.payload[`percent${e.name}`]}
                    </strong>
                  </p>
                  <p>
                    {nls.dashTotal}:{' '}
                    <strong>
                      {' '}
                      {Number(e.payload[e.name]) +
                        Number(e.payload[`transacted${e.name}`])}
                    </strong>
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      );
    }
    return null;
  };

  tableInfo = [
    ...tableInfo,
    { ...buildingData.total, area: <strong>Total</strong> },
  ];

  const modalHead = () => {
    return (
      <div className="transactions-modal-head-container">
        <IconTransactions cy="IconTransactionsModal" />
        <div className="transactions-modal-head-info-container">
          <h1>{buildingData.structure_data.building_name}</h1>
          <p>{buildingData.structure_data.address}</p>
        </div>
      </div>
    );
  };

  return (
    <>
      {statusModal === `open building transactions` && (
        <Modal
          cy="BuildingDetails"
          title={modalHead()}
          open={statusModal === `open building transactions`}
          close={() => dispatch(modalOpen(''))}
          size="large-full"
          borderHeader={true}
          actions
        >
          {buildingData && (
            <div className="modal-detail-transactions">
              <div className="modal-detail-container">
                <h6 className="header-detail-title">
                  {nls.transactionsDetail}
                </h6>
                <div className="row">
                  {structureData.map((el, index) => (
                    <div className="col-4" key={`structure_data-${index}`}>
                      <p
                        className="building-modal--body-container--key-value-pair"
                        data-cy={`BuildingModal${buildingData.structure_data.building_name}BodyInfo${el}`}
                      >
                        {nls[el]}: {buildingData.structure_data[el]}
                      </p>
                    </div>
                  ))}
                </div>
              </div>
              <div className="building-modal--table-container">
                <div className="building-modal--table-container--header">
                  <h6
                    className="header-table-title"
                    data-cy={`BuildingModal${buildingData.structure_data.building_name}EnterpriseAnalysis`}
                  >
                    {nls.panorama}
                  </h6>
                  {buildingData.closing_date && (
                    <span
                      className="building-modal--table-container--header-closing-date"
                      data-cy={`BuildingModal${buildingData.structure_data.building_name}ClosingDate`}
                    >
                      {nls.closingDate}: {buildingData.closing_date}
                    </span>
                  )}
                </div>
                <div className="building-modal--table-container--body">
                  <List
                    header={tableHeader}
                    data={tableInfo}
                    listCustom={(e) => {
                      const itemCustom = e;
                      tableHeader
                        .filter((td) =>
                          td.column.includes('percentual_transactioned--')
                        )
                        .forEach((td) => {
                          const anoTd = td.column.replace(
                            'percentual_transactioned--',
                            ''
                          );
                          if (typeof e.area !== 'string') {
                            itemCustom[td.column] = `${
                              e[`total_transacted_${anoTd}`]
                            } (${e[`transacted_percentual_${anoTd}`]} %)`;
                          } else {
                            itemCustom[td.column] = `${
                              e[`transacted_units_${anoTd}`]
                            } (${e[`percentual_transactioned_${anoTd}`]} %)`;
                          }
                        });
                      return itemCustom;
                    }}
                    cy={`BuildingModal${buildingData.structure_data.building_name}AnalysisTable`}
                    noData="Sem informação"
                  />
                </div>
              </div>
              {chartList.length > 0 ? (
                <div className="building-modal--charts-container">
                  <div className="building-modal--charts-container--header">
                    <h6
                      className="header-chart-title"
                      data-cy={`BuildingModal${buildingData.id}Charts`}
                    >
                      {nls.buildingCharts}
                    </h6>
                  </div>
                  <div className="building-modal--charts-container--body">
                    <div className="chart-box">
                      <label>Transacionados e existentes, por tipologia</label>
                      <div className="chart-box-view">
                        <ResponsiveContainer
                          data-cy={`transactionedOverExistingRealties${'graficio'}`}
                        >
                          <BarChart data={chartList}>
                            <Tooltip content={<CustomTooltip />} />
                            <XAxis dataKey="name" />
                            <YAxis />
                            {Object.keys(chartList[0]).map(
                              (test: any, i: number) => {
                                if (
                                  !test.includes('name') &&
                                  !test.includes('transacted') &&
                                  !test.includes('percent')
                                ) {
                                  indexColorCharts1++;
                                  return (
                                    <Fragment key={i}>
                                      <Bar
                                        isAnimationActive={false}
                                        dataKey={`transacted${test}`}
                                        stackId={test}
                                        fill={colors[indexColorCharts1]}
                                        label={{
                                          position: 'centerTop',
                                          fill: '#fff',
                                          formatter: (e: any) =>
                                            e > 0 ? e : null,
                                        }}
                                      />
                                      <Bar
                                        isAnimationActive={false}
                                        dataKey={`${test}`}
                                        stackId={test}
                                        fill={'#a2a4a4'}
                                        label={{
                                          position: 'top',
                                          formatter: (e: any) =>
                                            e > 0 ? e : null,
                                        }}
                                      />
                                    </Fragment>
                                  );
                                } else return null;
                              }
                            )}
                            <Brush
                              dataKey="name"
                              height={30}
                              stroke="#8884d8"
                            />
                          </BarChart>
                        </ResponsiveContainer>
                      </div>
                      <CustomLegend
                        data={Object.keys(chartList[0])}
                        chart="1"
                      />
                    </div>
                    <div className="chart-box">
                      <label>{nls.percentileTransactedByType}</label>
                      <div className="chart-box-view">
                        <ResponsiveContainer
                          data-cy={`transactionedOverExistingRealties${'graficio'}`}
                        >
                          <BarChart data={chartList}>
                            <Tooltip content={<CustomTooltipPercent />} />
                            <XAxis dataKey="name" />
                            <YAxis />
                            {Object.keys(chartList[0]).map(
                              (test: any, i: number) => {
                                if (
                                  !test.includes('transacted') &&
                                  !test.includes('name') &&
                                  !test.includes('percent')
                                ) {
                                  indexColorCharts2++;
                                  return (
                                    <Fragment key={i}>
                                      <Bar
                                        isAnimationActive={false}
                                        dataKey={`transacted${test}`}
                                        stackId={test}
                                        fill={colors[indexColorCharts2]}
                                        label={{
                                          position: 'centerTop',
                                          formatter: (e: any) =>
                                            e > 0 ? e : null,
                                        }}
                                      />
                                      <Bar
                                        isAnimationActive={false}
                                        dataKey={`${test}`}
                                        stackId={test}
                                        fill={'#a2a4a4'}
                                        label={{
                                          position: 'top',
                                          formatter: (e: any) =>
                                            e > 0 ? e : null,
                                        }}
                                      />
                                    </Fragment>
                                  );
                                } else return null;
                              }
                            )}
                            <Brush
                              dataKey="name"
                              height={30}
                              stroke="#8884d8"
                            />
                          </BarChart>
                        </ResponsiveContainer>
                      </div>
                      <CustomLegend
                        data={Object.keys(chartList[0])}
                        chart="2"
                      />
                    </div>
                  </div>
                </div>
              ) : null}
            </div>
          )}
        </Modal>
      )}
    </>
  );
};

export default BuildingDetailsModalTransactions;
